import ServiceBus from "servicestack/service-bus";
import ModalController from "webmodals/modal.controller";
import labels from "emun.on-demand/admin/_labels";

export default class DownloadImagesPromptController extends ModalController {
  constructor($uibModalInstance, options) {
    super($uibModalInstance);
    const $ctrl = this;
    $ctrl.bus = new ServiceBus();
    $ctrl.title = options.title || "Download Product Images...";
    $ctrl.subTitle = options.subTitle;
    $ctrl.product = options.product;
    $ctrl.labels = labels;
    $ctrl.sizes = ["hires", "large", "medium", "small", "thumbnail"];
    $ctrl.exts = ["png", "jpg"];
  }

  submit() {
    const $ctrl = this;
  }

  img(area, size, ext) {
    const $ctrl = this;
    return (
      $ctrl.$appConfig.serviceUrl +
      "cors?Attachment=1&FileName=" +
      $ctrl.product.id +
      "-" +
      area.label +
      "-" +
      size +
      "." +
      ext +
      "&Url=" +
      area.design.img(size, ext)
    );
  }

  overlayImg(area, overlay, size, ext) {
    const $ctrl = this;
    return (
      $ctrl.$appConfig.serviceUrl +
      "cors?Attachment=1&FileName=" +
      $ctrl.product.id +
      "-" +
      area.label +
      "-" +
      overlay.label +
      "-" +
      size +
      "." +
      ext +
      "&Url=" +
      area.design.img(overlay.euid + "/" + size, ext)
    );
  }
}
